import React from 'react';

const TOKEN_RE = /\{\{(\w+)\}\}|\*\*([^*]+)\*\*/g;

function textFragments(text, baseKey) {
  const lines = text.split('\n');
  const out = [];
  lines.forEach((line, i) => {
    if (line) out.push(<React.Fragment key={`t${baseKey}-${i}`}>{line}</React.Fragment>);
    if (i < lines.length - 1) out.push(<br key={`br${baseKey}-${i}`} />);
  });
  return out;
}

export default function parseScriptTokens(text, fields, setMergeField) {
  const els = [];
  let last = 0;
  let k = 0;
  let m;

  TOKEN_RE.lastIndex = 0;

  while ((m = TOKEN_RE.exec(text)) !== null) {
    if (m.index > last) {
      els.push(...textFragments(text.slice(last, m.index), k));
      k += 200;
    }

    if (m[1] !== undefined) {
      const field = m[1];
      const val = fields[field] || '';
      const width = Math.max((val || field).length, 4) * 8 + 20;
      els.push(
        <input
          key={`f-${k++}`}
          type="text"
          value={val}
          onChange={(e) => setMergeField(field, e.target.value)}
          placeholder={field}
          className="inline-block border-0 border-b-2 border-[#00AAFF] bg-transparent text-[#00AAFF] outline-none px-1 text-sm font-semibold align-baseline placeholder:text-[#00AAFF]/40 focus:border-[#0088DD]"
          style={{ width: `${width}px` }}
        />,
      );
    } else if (m[2] !== undefined) {
      els.push(<strong key={`b-${k++}`}>{m[2]}</strong>);
    }

    last = TOKEN_RE.lastIndex;
  }

  if (last < text.length) {
    els.push(...textFragments(text.slice(last), k));
  }

  return els;
}
